export default __webpack_public_path__ + "static/media/dozule.454ea9c2.jpg";